// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminWrap .card {
    display: inline-block;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/pre-screening-questions/admin_prescreener/admin_prescreener.component.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".adminWrap .card {\r\n    display: inline-block;\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
